import { render, staticRenderFns } from "./Children.vue?vue&type=template&id=c55d4f92&scoped=true&"
import script from "./Children.vue?vue&type=script&lang=javascript&"
export * from "./Children.vue?vue&type=script&lang=javascript&"
import style0 from "./Children.vue?vue&type=style&index=0&id=c55d4f92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55d4f92",
  null
  
)

export default component.exports